import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/i18n/LanguageContext";
import SeoMetadata from "@/components/SeoMetadata";

const PrivacyPolicy = () => {
  const { t, language } = useLanguage();

  const sections = [
    {
      titleKey: "privacy.s1.title",
      content: <p className="text-muted-foreground leading-relaxed">{t("privacy.s1.text")}</p>
    },
    {
      titleKey: "privacy.s2.title",
      content: (
        <>
          <p className="text-muted-foreground leading-relaxed mb-4">{t("privacy.s2.text")}</p>
          <ul className="list-disc list-inside text-muted-foreground space-y-2">
            {(["privacy.s2.i1","privacy.s2.i2","privacy.s2.i3","privacy.s2.i4","privacy.s2.i5"] as const).map(k => <li key={k}>{t(k)}</li>)}
          </ul>
        </>
      )
    },
    {
      titleKey: "privacy.s3.title",
      content: (
        <>
          <p className="text-muted-foreground leading-relaxed mb-4">{t("privacy.s3.text")}</p>
          <ul className="list-disc list-inside text-muted-foreground space-y-2">
            {(["privacy.s3.i1","privacy.s3.i2","privacy.s3.i3","privacy.s3.i4"] as const).map(k => <li key={k}>{t(k)}</li>)}
          </ul>
        </>
      )
    },
    {
      titleKey: "privacy.s4.title",
      content: <p className="text-muted-foreground leading-relaxed">{t("privacy.s4.text")}</p>
    },
    {
      titleKey: "privacy.s5.title",
      content: (
        <>
          <p className="text-muted-foreground leading-relaxed mb-4">{t("privacy.s5.text")}</p>
          <ul className="list-disc list-inside text-muted-foreground space-y-2">
            {(["privacy.s5.i1","privacy.s5.i2","privacy.s5.i3","privacy.s5.i4","privacy.s5.i5","privacy.s5.i6","privacy.s5.i7","privacy.s5.i8"] as const).map(k => <li key={k}>{t(k)}</li>)}
          </ul>
        </>
      )
    },
    {
      titleKey: "privacy.s6.title",
      content: <p className="text-muted-foreground leading-relaxed">{t("privacy.s6.text")}</p>
    },
    {
      titleKey: "privacy.s7.title",
      content: <p className="text-muted-foreground leading-relaxed">{t("privacy.s7.text")}</p>
    },
    {
      titleKey: "privacy.s8.title",
      content: <p className="text-muted-foreground leading-relaxed">{t("privacy.s8.text")}</p>
    },
  ] as const;

  const seoTitle = `${t("privacy.title")} | Gendera Service`;
  const seoDescription = t("seo.description.privacy" as any);

  return (
    <div className="min-h-screen bg-background">
      <SeoMetadata title={seoTitle} description={seoDescription} />
      <div className="bg-primary text-primary-foreground py-16 pt-40">
        <div className="container mx-auto px-4">
          <a href={`/${language}`}>
            <Button variant="ghost" className="text-primary-foreground hover:bg-primary-foreground/10 mb-6">
              <ArrowLeft className="w-4 h-4 mr-2" size={16} />
              {t("privacy.backHome")}
            </Button>
          </a>
          <h1 className="text-4xl md:text-5xl font-bold">{t("privacy.title")}</h1>
          <p className="text-primary-foreground/80 mt-4">{t("privacy.lastUpdate")}</p>
        </div>
      </div>
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto prose prose-lg">
          {sections.map(({ titleKey, content }) => (
            <section key={titleKey} className="mb-12">
              <h2 className="text-2xl font-bold text-foreground mb-4">{t(titleKey)}</h2>
              {content}
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
